module.exports = __webpack_public_path__ + "9ffb34741ba50796cfe72316be41ffdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/challenges/logo.png
// module id = 1810
// module chunks = 1